import { getCommunicationServiceAccounts, ICommunicationServiceAccount } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

export const getPhoneNumbers = async (email: string) => {
  const localStorageResponse: ICommunicationServiceAccount[] = JSON.parse(
    localStorage.getItem('communicationAccounts') ?? '[]'
  );
  let communicationAccounts: Array<ICommunicationServiceAccount> = [];
  if (localStorageResponse.length > 0) {
    communicationAccounts = localStorageResponse;
  } else {
    const response = await getCommunicationServiceAccounts();
    localStorage.setItem('communicationAccounts', JSON.stringify(response.data));
    communicationAccounts = response.data;
  }
  return constructSelectObj(communicationAccounts, email);
};

const constructSelectObj = (accounts: Array<ICommunicationServiceAccount>, email: string) => {
  const fromPhoneNumbers: Array<WsSelectObj> = [];
  accounts.forEach((account) => {
    account.phoneNumbers.forEach((phoneNumber) => {
      if (
        phoneNumber.canSendSms &&
        phoneNumber.sharedWith?.includes(email) &&
        account.serviceName != 'ZOOM'
      ) {
        fromPhoneNumbers.push({
          label: phoneNumber.phoneNumber,
          value: JSON.stringify({
            selectedAccount: account.id,
            from: phoneNumber.phoneNumber,
            serviceAccountId: account.serviceAccountId,
            serviceName: account.serviceName,
          }),
        });
      }
    });
  });
  return fromPhoneNumbers;
};
